import { useState } from 'react';
import { formatMetric } from '../../utils/formatMetric';
import EditAvgFuelModal from '../EditAvgFuelModal/EditAvgFuelModal';
import './AvgFuelCard.css';

type Props = {
  avgFuelBurn: number | null;
  fuelPrice: number | null;
  canEdit: boolean;
  onSaved: (next: {
    avg_fuel_burn_lph: number | null;
    fuel_price_per_liter: number | null;
  }) => void;
};

const AvgFuelCard = ({ avgFuelBurn, fuelPrice, canEdit, onSaved }: Props) => {
  const [showEdit, setShowEdit] = useState(false);
  const value = formatMetric(avgFuelBurn);
  const price = formatMetric(fuelPrice);

  return (
    <div className="aircraft-hub-card is-static avg-fuel-hub-card">
      <span className="aircraft-hub-label">
        Установленное среднее значение расхода топлива
      </span>
      <span className="aircraft-hub-value">
        <span className="aircraft-hub-number">
          {value}
          {value !== '—' ? (
            <span className="aircraft-hub-unit">л/ч</span>
          ) : null}
        </span>
      </span>
      <div className="avg-fuel-hub-meta">
        <span className="aircraft-hub-footer">
          Стоимость: {price !== '—' ? `${price} ₽/л` : 'не указана'}
        </span>
        {canEdit ? (
          <button
            type="button"
            className="avg-fuel-hub-edit"
            onClick={() => setShowEdit(true)}
          >
            Изменить
          </button>
        ) : null}
      </div>
      {showEdit ? (
        <EditAvgFuelModal
          avgFuelBurn={avgFuelBurn}
          fuelPrice={fuelPrice}
          onClose={() => setShowEdit(false)}
          onSaved={onSaved}
        />
      ) : null}
    </div>
  );
};

export default AvgFuelCard;
